(() => {
if (customElements.get('hoyo-coupon')) return;
customElements.define('hoyo-coupon', class extends HTMLElement {
  connectedCallback() {
    if (this.abort && !this.abort.signal.aborted) return;
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.status = this.querySelector('[role="status"]');
    this.manual = this.querySelector('[data-coupon-manual]');
    this.code = this.querySelector('[data-coupon-code]');
    this.countdown = this.querySelector('[data-coupon-countdown]');
    this.abort = new AbortController();
    this.busy = false;
    this.resetFeedback();
    this.checkDates();
    this.clock = setInterval(() => this.checkDates(), 30000);
    this.button.addEventListener('click', () => this.copy(), {signal: this.abort.signal});
    this.button.addEventListener('blur', () => this.hideManual(), {signal: this.abort.signal});
  }
  checkDates() {
    const start = Date.parse(this.dataset.start);
    const end = Date.parse(this.dataset.end);
    const now = Date.now();
    const active = (!Number.isFinite(start) || now >= start) && (!Number.isFinite(end) || now < end);
    this.hidden = !active;
    this.button.disabled = !active;
    if (this.countdown) {
      this.countdown.hidden = !active || !Number.isFinite(end);
      if (!this.countdown.hidden) {
        const minutes = Math.max(1, Math.ceil((end - now) / 60000));
        for (const [unit, value] of Object.entries({days: Math.floor(minutes / 1440), hours: Math.floor(minutes / 60) % 24, minutes: minutes % 60})) {
          this.countdown.querySelector('[data-coupon-' + unit + ']').textContent = value;
        }
      }
    }
    return active;
  }
  async copy() {
    if (!this.checkDates() || this.busy) return;
    const signal = this.abort.signal;
    const focusedAtStart = document.activeElement;
    this.busy = true;
    this.resetFeedback();
    const canWrite = typeof navigator.clipboard?.writeText === 'function';
    const compatibilityFirst = window.self !== window.top || !canWrite;
    let copied = false;
    try {
      if (compatibilityFirst) copied = this.copySelection();
      if (!copied && canWrite) {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          copied = true;
        } catch {
          if (signal.aborted || !this.isConnected) return;
          if (!compatibilityFirst && document.activeElement === focusedAtStart) copied = this.copySelection();
        }
      }
      if (signal.aborted || !this.isConnected) return;
      if (copied) {
        this.clearCodeSelection();
        this.classList.add('is-copied');
        this.button.setAttribute('aria-label', this.dataset.copied);
        this.status.textContent = this.dataset.copied;
        this.reset = setTimeout(() => {
          if (!signal.aborted && this.isConnected) this.resetFeedback();
        }, 2000);
      } else {
        this.showManual(signal, focusedAtStart);
      }
    } finally {
      if (!signal.aborted) {
        this.busy = false;
      }
    }
  }
  copySelection() {
    const previous = document.activeElement;
    const selection = window.getSelection();
    const ranges = [];
    for (let i = 0; selection && i < selection.rangeCount; i++) ranges.push(selection.getRangeAt(i).cloneRange());
    const input = document.createElement('textarea');
    input.value = this.dataset.code;
    input.readOnly = true;
    input.tabIndex = -1;
    input.style.cssText = 'position:fixed;inset:0;width:1px;height:1px;padding:0;margin:0;border:0;opacity:0;pointer-events:none;font-size:16px;';
    let copied = false;
    try {
      this.append(input);
      input.focus({preventScroll: true});
      input.select();
      input.setSelectionRange(0, input.value.length);
      copied = document.execCommand('copy') === true;
    } catch {
      copied = false;
    } finally {
      const restoreFocus = document.activeElement === input;
      input.remove();
      if (restoreFocus && previous?.isConnected) previous.focus({preventScroll: true});
      if (restoreFocus && selection) {
        selection.removeAllRanges();
        for (const range of ranges) {
          if (range.commonAncestorContainer.isConnected) selection.addRange(range);
        }
      }
    }
    return copied;
  }
  clearCodeSelection() {
    const selection = window.getSelection();
    if (selection && this.code.contains(selection.anchorNode)) selection.removeAllRanges();
  }
  showManual(signal, focusedAtStart) {
    this.manual.hidden = false;
    this.status.textContent = this.dataset.manual;
    if (document.activeElement === focusedAtStart && this.button.getClientRects().length) {
      const selection = window.getSelection();
      if (selection) {
        const range = document.createRange();
        range.selectNodeContents(this.code);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    this.manualReset = setTimeout(() => {
      if (!signal.aborted && this.isConnected) this.hideManual();
    }, 3500);
  }
  hideManual() {
    clearTimeout(this.manualReset);
    if (this.manual) this.manual.hidden = true;
    if (!this.classList.contains('is-copied') && this.status) this.status.textContent = '';
  }
  resetFeedback() {
    clearTimeout(this.reset);
    this.classList.remove('is-copied');
    this.hideManual();
    this.button.setAttribute('aria-label', this.dataset.copyLabel);
    this.status.textContent = '';
  }
  disconnectedCallback() {
    this.abort?.abort();
    clearTimeout(this.reset);
    clearTimeout(this.manualReset);
    clearInterval(this.clock);
  }
});
})();

